import React from "react";
import { Link } from "react-router-dom";
import { primaryNavigation } from "../navigation";
import { EmailIcon, LinkedInIcon } from "./ContactIcons";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">Magued Hanna</div>
            <p className="footer-text">
              UX and product design leadership focused on scalable systems,
              accessible experiences, and measurable product impact.
            </p>
          </div>

          <div className="footer-section">
            <h3 className="footer-heading">Quick Links</h3>
            <ul className="footer-links">
              {primaryNavigation.map((item) => (
                <li key={item.to}>
                  <Link to={item.to}>{item.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer-section">
            <h3 className="footer-heading">Connect</h3>
            <ul className="footer-social-links">
              <li>
                <a
                  className="footer-social-link"
                  href="https://www.linkedin.com/in/maguedh/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="LinkedIn profile (opens in a new tab)"
                >
                  <LinkedInIcon />
                </a>
              </li>
              <li>
                <a
                  className="footer-social-link"
                  href="mailto:magued@maguedhanna.com"
                  aria-label="Email Magued Hanna"
                >
                  <EmailIcon />
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {currentYear} Magued Hanna. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
